import { cloneElement, forwardRef, useMemo } from "react";
import { useMergeRefs } from "sprout-hooks";
export const PopoverReference = /*#__PURE__*/ forwardRef(function PopoverReferenceForwardRef(props, ref) {
    const { children , setReferenceElement  } = props;
    const mergedRefs = useMergeRefs(setReferenceElement, ref);
    const memoProp = useMemo(()=>({
            ref: mergedRefs
        }), [
        mergedRefs
    ]);
    return /*#__PURE__*/ cloneElement(children, memoProp);
});
